module.exports = __webpack_public_path__ + "img/intensive-cert-375.4b9801f2.jpg";